(function () {

  'use strict';


  /* =========================================================
     基础
  ========================================================= */

  const root =
    window.Shopify?.routes?.root || '/';


  let adding = false;


  /* =========================================================
     找右上角购物车
  ========================================================= */

  function getCartIcon() {

    return (
      document.querySelector('[data-cart-icon]') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href$="/cart"]') ||
      document.querySelector('a[href*="/cart"]')
    );

  }


  /* =========================================================
     找商品图片
  ========================================================= */

  function getProductImage(form) {

    const selectors = [

      '.js-cart-fly-image',

      '.product-media img',

      '.product-gallery img',

      '.product__media img',

      '.product-media-gallery img',

      '.product-main-image img',

      '[data-product-media] img'

    ];


    for (const selector of selectors) {

      const image =
        document.querySelector(selector);

      if (
        image &&
        image.offsetWidth > 80 &&
        image.offsetHeight > 80
      ) {
        return image;
      }

    }


    const section =
      form.closest('section');


    if (section) {

      const images =
        [...section.querySelectorAll('img')];


      return images.find(
        img =>
          img.offsetWidth > 150 &&
          img.offsetHeight > 150
      );

    }


    return null;

  }


  /* =========================================================
     飞入购物车动画
  ========================================================= */

  function flyToCart(image) {

    const cartIcon =
      getCartIcon();


    if (!image || !cartIcon) return;


    const start =
      image.getBoundingClientRect();


    const end =
      cartIcon.getBoundingClientRect();


    const clone =
      image.cloneNode(true);


    clone.style.position = 'fixed';

    clone.style.left =
      start.left + 'px';

    clone.style.top =
      start.top + 'px';

    clone.style.width =
      start.width + 'px';

    clone.style.height =
      start.height + 'px';

    clone.style.objectFit = 'cover';

    clone.style.borderRadius = '18px';

    clone.style.zIndex = '999999';

    clone.style.pointerEvents = 'none';

    clone.style.boxShadow =
      '0 14px 40px rgba(120,75,170,.25)';

    clone.style.transition =
      'all .72s cubic-bezier(.22,.8,.26,1)';


    document.body.appendChild(clone);


    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        clone.style.left =
          (end.left + end.width / 2 - 20) + 'px';

        clone.style.top =
          (end.top + end.height / 2 - 20) + 'px';

        clone.style.width = '40px';

        clone.style.height = '40px';

        clone.style.opacity = '.25';

        clone.style.transform =
          'rotate(8deg) scale(.5)';

      });

    });


    setTimeout(() => {

      clone.remove();


      cartIcon.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.24)' },
          { transform: 'scale(.94)' },
          { transform: 'scale(1)' }
        ],
        {
          duration: 380,
          easing: 'ease-out'
        }
      );

    }, 720);

  }


  /* =========================================================
     Header 数量
  ========================================================= */

  function updateCartCount(count) {

    const selectors = [

      '[data-cart-count]',

      '.cart-count',

      '.cart-count-bubble',

      '.cart-count-badge'

    ];


    let found = false;


    selectors.forEach(selector => {

      document
        .querySelectorAll(selector)
        .forEach(el => {

          found = true;

          el.textContent = count;

          el.hidden = false;

          el.style.display =
            count > 0 ? '' : 'none';

        });

    });


    /*
      如果主题原来没有数量标签，
      自动在购物车图标上创建
    */

    if (!found && count > 0) {

      const cart =
        getCartIcon();


      if (cart) {

        cart.style.position =
          cart.style.position || 'relative';


        let badge =
          cart.querySelector('.nn-auto-cart-count');


        if (!badge) {

          badge =
            document.createElement('span');

          badge.className =
            'nn-auto-cart-count';

          cart.appendChild(badge);

        }


        badge.textContent = count;

      }

    }

  }


  /* =========================================================
     Toast
  ========================================================= */

  function showToast(item) {

    document
      .querySelectorAll('.nn-cart-toast')
      .forEach(el => el.remove());


    const toast =
      document.createElement('div');


    toast.className =
      'nn-cart-toast';


    const image =
      item.featured_image?.url ||
      item.image ||
      '';


    toast.innerHTML = `

      <button
        class="nn-cart-toast-close"
        aria-label="Close"
        type="button"
      >
        ×
      </button>

      <div class="nn-cart-toast-check">
        ✓
      </div>

      <div class="nn-cart-toast-title">
        Added to your bag ♡
      </div>

      <div class="nn-cart-toast-product">

        ${
          image
          ?
          `
          <img
            src="${image}"
            alt=""
          >
          `
          :
          ''
        }

        <div>

          <strong>
            ${escapeHtml(item.product_title || item.title)}
          </strong>

          ${
            item.variant_title &&
            item.variant_title !== 'Default Title'
            ?
            `
            <small>
              ${escapeHtml(item.variant_title)}
            </small>
            `
            :
            ''
          }

        </div>

      </div>

      <div class="nn-cart-toast-actions">

        <a
          href="${root}cart"
          class="nn-cart-toast-view"
        >
          View bag
        </a>

        <a
          href="/checkout"
          class="nn-cart-toast-checkout"
        >
          Checkout
        </a>

      </div>

      <button
        type="button"
        class="nn-cart-toast-continue"
      >
        Continue shopping
      </button>

    `;


    document.body.appendChild(toast);


    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });


    toast
      .querySelector('.nn-cart-toast-close')
      ?.addEventListener(
        'click',
        () => closeToast(toast)
      );


    toast
      .querySelector('.nn-cart-toast-continue')
      ?.addEventListener(
        'click',
        () => closeToast(toast)
      );


    setTimeout(() => {

      if (
        document.body.contains(toast)
      ) {
        closeToast(toast);
      }

    }, 6500);

  }


  function closeToast(toast) {

    toast.classList.remove('is-visible');

    setTimeout(
      () => toast.remove(),
      260
    );

  }


  function escapeHtml(text) {

    const div =
      document.createElement('div');

    div.textContent =
      text || '';

    return div.innerHTML;

  }


  /* =========================================================
     获取购物车
  ========================================================= */

  async function refreshCart() {

    try {

      const response =
        await fetch(
          root + 'cart.js',
          {
            headers: {
              'Accept':
                'application/json'
            }
          }
        );


      const cart =
        await response.json();


      updateCartCount(
        cart.item_count
      );


      document.dispatchEvent(
        new CustomEvent(
          'nekoneko:cart-updated',
          {
            detail: cart
          }
        )
      );


      return cart;


    } catch (error) {

      console.error(
        'Cart refresh failed:',
        error
      );

    }

  }


  /* =========================================================
     AJAX ADD TO CART
  ========================================================= */

  document.addEventListener(
    'submit',
    async function (event) {

      const form =
        event.target.closest(
          'form[action*="/cart/add"]'
        );


      if (!form) return;


      /*
        可以给某个 form 加 data-no-ajax-cart
        来取消 AJAX
      */

      if (
        form.hasAttribute(
          'data-no-ajax-cart'
        )
      ) {
        return;
      }


      event.preventDefault();


      if (adding) return;

      adding = true;


      const button =
        form.querySelector(
          '[type="submit"]'
        );


      const originalText =
        button
        ?
        button.innerHTML
        :
        '';


      if (button) {

        button.disabled = true;

        button.innerHTML =
          'Adding... ♡';

      }


      const image =
        getProductImage(form);


      try {

        const formData =
          new FormData(form);


        const response =
          await fetch(
            root + 'cart/add.js',
            {
              method: 'POST',

              headers: {
                'Accept':
                  'application/json'
              },

              body:
                formData
            }
          );


        const item =
          await response.json();


        if (!response.ok) {

          throw new Error(
            item.description ||
            item.message ||
            'Unable to add this item.'
          );

        }


        /* 动画 */

        flyToCart(image);


        /* 数量 */

        await refreshCart();


        /* 提示 */

        setTimeout(
          () => showToast(item),
          280
        );


        if (button) {

          button.innerHTML =
            'Added ✓';


          setTimeout(() => {

            button.innerHTML =
              originalText;

          }, 1100);

        }


      } catch (error) {

        console.error(error);


        alert(
          error.message ||
          'Unable to add this item. Please try again.'
        );


        if (button) {

          button.innerHTML =
            originalText;

        }


      } finally {

        if (button) {

          setTimeout(() => {

            button.disabled = false;

          }, 500);

        }


        adding = false;

      }

    },
    true
  );


  /* 第一次载入同步数量 */

  document.addEventListener(
    'DOMContentLoaded',
    refreshCart
  );


})();